import { createContext, useContext, useEffect, useState } from 'react';
import { usersApi } from '@/api';
import type { User } from '@/types';

interface InspectorProfileContextValue {
  profile: User | null;
  setProfile: (user: User) => void;
}

const InspectorProfileContext = createContext<InspectorProfileContextValue>({
  profile: null,
  setProfile: () => {},
});

export function InspectorProfileProvider({ children }: { children: React.ReactNode }) {
  const [profile, setProfile] = useState<User | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await usersApi.getProfile();
        if (!cancelled && res.success && res.data) setProfile(res.data);
      } catch {
        // Non-fatal — sidebar falls back to Clerk-derived values.
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <InspectorProfileContext.Provider value={{ profile, setProfile }}>
      {children}
    </InspectorProfileContext.Provider>
  );
}

export function useInspectorProfile(): InspectorProfileContextValue {
  return useContext(InspectorProfileContext);
}
